export default {"src":"/_next/static/media/escape_room.d57de43f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};